const i18n_fields = {
  EN: [
    { key: 'id', label: 'No', sortable: false, thStyle: 'width: 5%' },
    // { key: 'type', label: 'Type', sortable: false, thStyle: 'width: 8%' },
    { key: 'created_at', label: 'DateTime', sortable: false, thStyle: 'width: 15%' },
    { key: 'action', label: 'Action', sortable: false, thStyle: 'width: 10%' },
    { key: 'target', label: 'Target', sortable: false },
  ],
  KO : [
    { key: 'id', label: 'No', sortable: false, thStyle: 'width: 5%' },
    // { key: 'type', label: 'Type', sortable: false, thStyle: 'width: 8%' },
    { key: 'created_at', label: '시간', sortable: false, thStyle: 'width: 15%' },
    { key: 'action', label: '행동', sortable: false, thStyle: 'width: 10%' },
    { key: 'target', label: '타겟', sortable: false },
  ],
  JP: [
    { key: 'id', label: 'No', sortable: false, thStyle: 'width: 5%' },
    // { key: 'type', label: 'タイプ', sortable: false, thStyle: 'width: 8%' },
    { key: 'created_at', label: '日付/時間', sortable: false, thStyle: 'width: 15%' },
    { key: 'action', label: 'アクション', sortable: false, thStyle: 'width: 10%' },
    { key: 'target', label: 'ターゲット', sortable: false },
  ]
}

const fields = {
  i18n_fields
}

export default fields